'use strict';

var AppState = require('app_state');
var Consts = require('consts');
var Devices = require('models/devices');
var DropDownList = require('utils/dropdown_list');
var DeviceDropDownList = require('utils/device_dropdown_list');
var I18N = require('utils/i18n');
var Misc = require('utils/misc');
var Strings = require('utils/strings');
var FieldValue = require('utils/field_value');
var LINK = require('../components/common/templates/link');
var QUICK_NAVIGATION = require('../components/common/templates/quick_navigation_base');
var QuickNavigationLinks = require('../components/common/templates/quick_navigation');

Handlebars.registerHelper('TR', function (input) {
    return I18N.TR(input);
});

Handlebars.registerHelper('TR_DATAPOINT', function (device, input) {
    return I18N.DATAPOINT_BY_ID(device, input);
});

Handlebars.registerHelper('TR_DATAPOINT_CATEGORY', function (category, input) {
    return I18N.DATAPOINT(category, input);
});

Handlebars.registerHelper('TR_SELECTOR', function () {
    // get all available languages
    var languages = I18N.languagesList();

    // create language selection popover element
    var result = '';
    _.each(languages, function (lang) {
        result += '<span class="js-lang" id="' + lang.key + '">' + lang.value + '</span></br>';
    });
    return result;
});

var handlebarsTime = function (input) {
    return new Handlebars.SafeString(Misc.formatDate(input));
};

Handlebars.registerHelper('TIMEEX', function (input) {
    if (Misc.undefineDate(input) === undefined) return '---';
    return handlebarsTime(input);
});

Handlebars.registerHelper('TIME', function (input) {
    return handlebarsTime(input);
});

Handlebars.registerHelper('TIMEFORMAT', function (time, format) {
    var ts = moment(time).locale(I18N.language);
    return ts.format(format);
});

Handlebars.registerHelper('TYPE_DEVICE', function (deviceCategory, input, model) {
    // switch on device type
    var result;
    switch (deviceCategory) {
        case 'Actuator':
            result = Consts.actuatorTypeString(input);
            break;
        case 'Virtual':
            result = I18N.TR('Virtuelles Gerät');
            break;
        case 'FakeGateway':
            result = I18N.TR('Simuliertes Gateway');
            break;
        case 'FakeMeter':
            result = I18N.TR('Simulierter Zähler');
            break;
        case 'Gateway':
        case 'Gateway-RF':
        case 'SamHomeGrid':
            result = Consts.gatewayTypeString(input);
            break;
        case 'Controller':
        case '55xx56xx':
            if (model && Devices.IsEthernetController(model)) {
                return 'TROVIS 5578-E';
            }
            result = Consts.controllerTypeString(input);
            break;
        case 'Meter':
            result = Consts.meterTypeString(input);
            break;
        case 'Sensor':
            result = Consts.sensorTypeString(input);
            break;
        default: // modbus
            result = input != '' && input != '0' ? input : I18N.TR('Unbekannter Typ');
    }
    return new Handlebars.SafeString(result);
});

Handlebars.registerHelper('TYPE_MODBUS', function (input) {
    return new Handlebars.SafeString(input != '' && input != '0' ? input : I18N.TR('Unbekannter Typ'));
});

Handlebars.registerHelper('TYPE_CONTROLLER', function (input, model) {
    if (Devices.IsEthernetController(model)) {
        return 'TROVIS 5578-E';
    }
    return new Handlebars.SafeString(Consts.controllerTypeString(input));
});

Handlebars.registerHelper('TYPE_CONTROLLER_VALID', function (input, options) {
    return input in Consts.ControllerTypes ? options.fn(this) : options.inverse(this);
});

Handlebars.registerHelper('TYPE_METER', function (input) {
    return new Handlebars.SafeString(Consts.meterTypeString(input));
});

Handlebars.registerHelper('TYPE_GATEWAY', function (input) {
    return new Handlebars.SafeString(Consts.gatewayTypeString(input));
});

Handlebars.registerHelper('TYPE_GATEWAY_VALID', function (input, options) {
    return input in Consts.GatewayTypes ? options.fn(this) : options.inverse(this);
});

var getDeviceLink = function (id, name, category, model) {
    if (id === 0) {
        return '';
    }

    if (!category || !name) {
        var deviceInfo = AppState.getDeviceInfo(id);
        category = category || deviceInfo.category;
        name = name || deviceInfo.name;
    }

    var categoryData = Consts.DeviceCategory[category] || {};
    return (
        '<i class="' +
        categoryData.icon +
        ' m-r-5"></i><a href="' +
        categoryData.url +
        '/' +
        id +
        '">' +
        Handlebars.escapeExpression(name) +
        '</a>' +
        QUICK_NAVIGATION()
    );
};

var deviceLinkFct = function (id) {
    if (!id || id === 0) {
        return '--';
    }

    var info = AppState.getDeviceInfo(id);

    if (info.category) {
        // create link based on available device
        var categoryData = Consts.DeviceCategory[info.category] || {};
        return (
            '<i class="' +
            categoryData.icon +
            ' m-r-5"></i><a href="' +
            categoryData.url +
            '/' +
            id +
            '">' +
            Handlebars.escapeExpression(info.name) +
            '</a>'
        );
    }

    return I18N.TR('Unbekanntes Gerät');
};

Handlebars.registerHelper('DEVICE_LINK', deviceLinkFct);

Handlebars.registerHelper('VALUE_SELECTED', function (selection, val) {
    if (selection === undefined || selection.length == 0) {
        return '';
    }
    return _.where(selection, { uniqueId: val.uniqueId }).length == 1 ? 'selected' : '';
});

Handlebars.registerHelper('PERMISSION_ROLE', function (model) {
    return Misc.getPermissionsRoleName(model);
});

Handlebars.registerHelper('PERMISSION_LABEL', function (permissionsId) {
    return Consts.PermissionsLabel[permissionsId] || permissionsId;
});

var labelList = function (model) {
    var result = '';

    // append public labels
    result = _.map(model.tags, function (item) {
        return '<span class="label label-tags">' + Handlebars.escapeExpression(item) + '</span> ';
    }).join('');

    if (result != '' && model.groups && model.groups.length > 0) {
        result += '&nbsp;&nbsp;';
    }

    // append private labels
    result += _.map(model.groups, function (item) {
        return '<span class="label label-groups">' + Handlebars.escapeExpression(item) + '</span> ';
    }).join('');

    return result;
};

var getStandardColValue = function (model, attribute) {
    var result = Misc.getDeviceModelValue(model, attribute);
    var fi = model.formatInfos ? model.formatInfos[attribute] : undefined;

    switch (result.source) {
        case 'data':
            var valueInfo = Misc.formatValueUnit(
                result.value,
                attribute,
                AppState.uniqueColumns(model.category),
                undefined,
                fi
            );
            result = valueInfo.value + ' ' + Handlebars.escapeExpression(valueInfo.unit);
            break;
        default:
            result = Misc.formatDeviceAttr(model, attribute);
            break;
    }

    if (result === undefined) result = '--';

    return new Handlebars.SafeString(result);
};

var getDeviceDesignation = function (model) {
    switch (model.category) {
        case Consts.Category.Controller:
            return Handlebars.helpers.TYPE_CONTROLLER(model.type, model);
        case Consts.Category.Meter:
            return Handlebars.helpers.TYPE_METER(model.type);
        case Consts.Category.GenericModbus:
            return Handlebars.helpers.TYPE_MODBUS(model.type);
    }

    // default: gateway -> shows "unknown" if any other category
    return Handlebars.helpers.TYPE_GATEWAY(model.type);
};

var deviceColumnData = function (model, attribute) {
    var getQuickAnalysisLink = function () {
        var qaInfo = Consts.RankingRuleQuickAnalysisInfo[model.rule_id];
        if (qaInfo) {
            var baseLink = Consts.DeviceCategory[model.category].url + '/' + model.device_id + '/analyze-predefined';
            var analyzeConfig = '?show_events=' + (qaInfo.showEvents ? 'true' : 'false');

            // chart period
            analyzeConfig += Misc.getQuickAnalyzePeriod(
                model.begin_time,
                model.end_time,
                qaInfo.deltaStart || 20 * 60 * 1000,
                qaInfo.deltaEnd || 20 * 60 * 1000
            );

            // chart content
            analyzeConfig += Misc.getQuickAnalyzeConfig(qaInfo.dataList, {
                category: model.category,
                columns: AppState.Cache.columns,
            });

            return baseLink + analyzeConfig;
        }

        return '';
    };

    switch (attribute) {
        case '#_plain_name':
            return getStatusIcon(model.status, true) + ' ' + Handlebars.escapeExpression(model.name);
        case '#_name':
            var linkText = getStatusIcon(model.status) + ' ' + Handlebars.escapeExpression(model.name);
            var link = LINK({ url: Misc.getDeviceURL(model.category, model.id, model.tab), text: linkText });
            return $.isEmptyObject(model.capabilities) ? link : link + QUICK_NAVIGATION();
        case '#_name_link':
            var linkText = Handlebars.escapeExpression(model.name);
            var link = LINK({ url: Misc.getDeviceURL(model.category, model.id, model.tab), text: linkText });
            return $.isEmptyObject(model.capabilities) ? link : link + QUICK_NAVIGATION();
        case '#_rule_name':
            var template = require('utils/templates/ranking_rule_info');
            return template({
                id: model.id,
                name: model.rule_name,
                info: Consts.RankingRuleInfos[model.rule_id],
                link: getQuickAnalysisLink(),
            });
        case '#_type':
            return getDeviceDesignation(model);
        case '#_wired_to':
            return Handlebars.helpers.DEVICE_LINK(model.parent);
        case '#_tags':
            return labelList(model);
        case '#_groups':
            return labelList(model);
        case '#_category':
            return getTypeIcon(model.category) + ' ' + getTypeText(model.category);
        case '#_filter':
            return AppState.filterToStr(model.filter);
        case '#_ranking':
            return getRankingBar(model.ranking);
        default:
            return getStandardColValue(model, attribute);
    }
};

var getRankingBar = function (ranking) {
    var percent = ranking > 1000 ? 100 : Math.ceil(ranking / 10);
    var style = Math.floor(percent / 10);

    return (
        '<div class="progress">' +
        '<div div class="progress-bar progress-bar-ranking-' +
        style +
        '" role="progressbar" style="width: ' +
        percent +
        '%;">' +
        '</div></div>'
    );
};

var getStatusIcon = function (status, noInteraction) {
    var actionClass = noInteraction ? '' : 'clickable';
    if (!AppState.availableColumnData('status')) {
        // status info not available -> hide
        return '';
    }

    var icon = Misc.convertValue(status, Consts.DeviceStatus, Consts.Icons);
    if (icon != '') {
        return '<i tabindex="0" class="' + actionClass + ' js-popover-anchor m-r-5 ' + icon + '"></i>';
    }

    return '';
};

var getTypeIcon = function (type) {
    var icon = Misc.convertValue(type, Consts.Category, Consts.Icons);
    if (icon != '') {
        return '<i class="' + icon + ' m-r-5"></i>';
    }

    return '';
};

var getTypeText = function (type) {
    return Misc.convertValue(type, Consts.Category, Consts.DeviceTypeText, I18N.TR('Unbekannter Typ'));
};

Handlebars.registerHelper('EACH-COLS', function (items, colCount, contentOrClass, content2) {
    var content = content2 || contentOrClass;
    if (!items || !items.length) return '';
    var contentRows = _.map(items, function (item) {
        return new Handlebars.SafeString(content.fn(item));
    });
    return Misc.htmlCols(contentRows, colCount, content2 ? contentOrClass : undefined);
});

Handlebars.registerHelper('COMPACT_DEVICE_LIST', function (devices, deviceCount) {
    var result = '';
    _.each(devices, function (m) {
        result +=
            LINK({
                url: Misc.getDeviceURL(m.category, m.id),
                text: getStatusIcon(m.status) + ' ' + Handlebars.escapeExpression(m.name),
            }) + '<br/>';
    });
    if (deviceCount && deviceCount > devices.length) {
        result += '+ ' + (deviceCount - devices.length) + ' ' + I18N.TR('weitere');
    }
    return result;
});

var mailColumnData = function (model, attribute) {
    switch (attribute) {
        case '#_targets':
            if (model.targets.length === 0 || model.targets[0] === '') {
                return '<div class="table-columns">--</div>';
            }

            var targetList = '';

            _.each(model.targets, function (target) {
                targetList +=
                    '<i class="fa fa-' +
                    (target.includes('@') ? 'envelope-o' : 'phone') +
                    ' m-r-10" />' +
                    Handlebars.escapeExpression(target) +
                    '<br>';
            });

            return '<div class="table-columns">' + targetList + '</div>';
        case '#_name':
            return (
                '<a href="#" id="' +
                Handlebars.escapeExpression(model.id) +
                '" class="js-edit-mailbox">' +
                Handlebars.escapeExpression(model.name) +
                '</a>'
            );
        case '#_alarms':
            return Handlebars.escapeExpression(model.alarms);
        case '#_reports':
            return Handlebars.escapeExpression(model.reports);
    }
};

var userAdminColumnData = function (model, attribute) {
    switch (attribute) {
        case '#_name':
            var result = '';
            var name = Handlebars.escapeExpression(model.name);
            if (model.id === AppState.user.id) {
                result += '<span class="label label-info"><i class="fa fa-user"></i></span> ' + name;
            } else if (!model.is_owner) {
                result += '<a id="' + model.id + '" class="js-configure-user" href="#">' + name + '</a>';
            } else {
                result += name;
            }
            if (model.is_owner === true) {
                result += ' <i class="fa fa-star text-warning"></i>';
            }
            if (AppState.user.attributes.permissions && AppState.user.attributes.permissions.length > 0) {
                result += '<br/><span><em class="email">' + Handlebars.escapeExpression(model.email) + '</em></span>';
            }
            if (model.approver !== '') {
                result +=
                    '<br><small>' +
                    I18N.TR('Freigegeben von') +
                    ' ' +
                    Handlebars.escapeExpression(model.approver) +
                    '</small>';
            }
            return result;
        case '#_access_rights':
            var keys = _.keys(model.access_rights);

            if (keys.length === 0) {
                // no permissions? -> do not show table
                return '';
            }

            // split access right list into two columns
            var rightIds = keys.sort();
            var leftIds = rightIds.splice(0, Math.ceil(rightIds.length / 2));

            model.left = {};
            _.each(leftIds, function (e) {
                model.left[e] = model.access_rights[e];
            });

            model.right = {};
            _.each(rightIds, function (e) {
                model.right[e] = model.access_rights[e];
            });

            var template = require('utils/templates/permission_list');
            return template(model);
    }
};

var gatewayStatistic = function (model, attribute) {
    if (attribute === '#_name') {
        return deviceColumnData(model, attribute);
    }

    var timeActiveDays = (new Date().getTime() - new Date(model.registration).getTime()) / (24 * 60 * 60 * 1000);

    if (attribute === 'offline_events') {
        return model.data[attribute];
    }

    if (attribute.indexOf('day') != -1 && timeActiveDays < 2) {
        return '--';
    }
    if (attribute.indexOf('week') != -1 && timeActiveDays < 8) {
        return '--';
    }
    if (attribute.indexOf('month') != -1 && timeActiveDays < 31) {
        return '--';
    }

    if (attribute.startsWith('data')) {
        var formatedValue = Strings.adjustUnits(model.data[attribute], 'B');
        return formatedValue.value.toFixed(2) + ' ' + formatedValue.unit;
    }
    return model.data[attribute] + ' %';
};

var companyUser = function (model, attribute) {
    var hasPermission = function (permission) {
        return (
            undefined !=
            _.find(model.permissions, function (num) {
                return num === Consts.PermissionsCompany[permission];
            })
        );
    };
    // returns true if the model has the given permission
    switch (attribute) {
        case '#_name':
            var name = Handlebars.escapeExpression(model.name);

            // standard user view (= no permission info)? -> show name only
            if (model.permissions.length === 0) {
                return name;
            }

            // highlight the current user in the administrator table
            var userIcon =
                model.id === AppState.user.id
                    ? '<span class="label label-info"><i class="fa fa-user"></i></span> '
                    : '';

            // return HTML
            return (
                '<a href="#" id="' +
                model.id +
                '" class="js-company-user">' +
                userIcon +
                name +
                ' </a>' +
                '<br/><span><em class="email">' +
                Handlebars.escapeExpression(model.email) +
                '</em></span>'
            );

        case '#_EditDevices':
            var canAdd = hasPermission('AddDevices');
            var canRemove = hasPermission('RemoveDevices');
            var canView = hasPermission('ViewDevices');

            if (!canAdd && !canRemove && !canView) {
                return '--';
            }

            var icon = '<i class="fa fa-' + (canView ? 'eye' : 'check-circle');
            icon += ' text-' + (canAdd && canRemove ? 'success' : 'warning') + '"></i> ';
            icon += canRemove ? '' : canView ? I18N.TR('betrachten') : I18N.TR('hinzufügen');
            return icon;

        default:
            // model contains the current permission (=attribute)?
            if (hasPermission(attribute.split('_')[1])) {
                return '<i class="fa fa-check-circle text-success"></i>';
            }
            return '--';
    }
};

var valueColumnData = function (model, attribute) {
    var getTranslatedName = function () {
        return I18N.DATAPOINT_BY_ID(model.device, model.name);
    };

    switch (attribute) {
        case '#_name':
            if (model.type == 'UNSPECIFIED') {
                // unknown value type -> just show the name
                return Handlebars.escapeExpression(getTranslatedName());
            }
            if (model.is_protected === true) {
                // protected value -> no configuration allowed
                return '<i class="fa fa-thumb-tack m-r-10"></i>' + Handlebars.escapeExpression(getTranslatedName());
            }
            if (model.type.startsWith('SCR')) {
                // calculated value -> no configuration allowed
                return '<i class="fa fa-calculator m-r-10"></i>' + Handlebars.escapeExpression(getTranslatedName());
            }
            if (model.is_pushed === false) {
                // calculated value -> no configuration allowed
                return '<i class="fa fa-unlink m-r-10"></i>' + Handlebars.escapeExpression(getTranslatedName());
            }

            var icon = model.spec != 0 ? '' : '<i class="fa fa-hand-o-right m-r-10"></i>';

            // show as links -> open configuration dialog
            return (
                '<a id="' +
                model.id +
                '" class="js-configure-value" href="#">' +
                icon +
                Handlebars.escapeExpression(getTranslatedName()) +
                '</a>'
            );
        case '#_name_text':
            return Handlebars.escapeExpression(getTranslatedName());
        case '#_value':
            if (model.data === undefined) {
                return '--';
            }
            var context = undefined;

            var getValueBuffer = function () {
                var values = [];
                for (var i = 0; i < model.length; i++) {
                    values.push(model.data[model.type + '_' + (model.nr + i)]);
                }
                return values;
            };

            switch (model.format) {
                case 'ascii':
                    context = {
                        value: Strings.formatAsciiValue(getValueBuffer(), 'ascii'),
                    };
                    break;
                case 'p-ascii':
                    context = {
                        value: Strings.formatAsciiValue(getValueBuffer(), 'p-ascii'),
                    };
                    break;
                case 'h-ascii':
                    context = {
                        value: Strings.formatAsciiValue(
                            model.length >= 3 ? getValueBuffer() : [model.data[model.type + '_' + model.nr]],
                            'h-ascii'
                        ),
                    };
                    break;
                default:
                    // default value display
                    context = Misc.getValueDisplayInfos(
                        model.data[model.type + '_' + model.nr],
                        model.type,
                        model.format,
                        model.unit,
                        model.display_unit,
                        model.is_unit_fixed
                    );
            }

            // integrate model base infos
            context.id = model.id;
            switch (model.transfer_mode) {
                case Consts.TransferMode.None:
                    context.icon = model.smartTemp ? 'fa fa-flask' : 'glyphicon glyphicon-pencil';
                    context.buttonColor = model.smartTemp && !model.isDryRun ? 'inverse' : 'white';
                    break;
                case Consts.TransferMode.Value:
                    context.icon = 'fa fa-exchange';
                    context.buttonColor = 'inverse';
                    break;
                case Consts.TransferMode.Weather:
                    context.icon = 'wi wi-day-cloudy';
                    context.buttonColor = 'inverse';
                    break;
            }
            // inconsistent? -> overwrite transfer mode icon
            context.icon = model.isInconsistent ? 'fa fa-hourglass' : context.icon;

            context.isInconsistent = model.isInconsistent;
            context.isEditable = model.isEditable;
            context.is_remote_value = model.transfer_mode != Consts.TransferMode.None;
            context.smartTemp = model.smartTemp;

            var template = require('utils/templates/value_display');
            return template(context);
        case '#_update_class':
            var updateClassInfo = undefined;

            if (model.update_time >= 1) {
                if (model.update_time == 1) {
                    updateClassInfo = I18N.TR('jede Minute');
                } else {
                    var prefix = I18N.TR('alle') + ' ';
                    var displayFrequency = model.update_time;
                    var suffix = '';

                    if (model.update_time < 120) {
                        suffix = I18N.TR('Minuten');
                    } else if (model.update_time < 2880) {
                        suffix = I18N.TR('Stunden');
                        displayFrequency = Math.floor(model.update_time / 60);
                    } else {
                        suffix = I18N.TR('Tage');
                        displayFrequency = Math.floor(model.update_time / 1440);
                    }

                    updateClassInfo = prefix + displayFrequency + ' ' + suffix;
                }
            }
            return (
                '<strong>' + model.update_class + '</strong>' + (updateClassInfo ? ' (' + updateClassInfo + ')' : '')
            );
    }

    if (attribute.startsWith('#_')) {
        attribute = attribute.substring(2);
    }
    return Handlebars.escapeExpression(model[attribute] || '--');
};

Handlebars.registerHelper('DEVICE_STATUS', function (status) {
    return getStatusIcon(status);
});

Handlebars.registerHelper('DISPLAY_VALUE', function (model, value, attribute) {
    if (!attribute) {
        value = model.data[model.type + '_' + model.nr];
    }
    var valueDisplayInfos = Misc.getValueDisplayInfos(
        value,
        model.type,
        model.format,
        model.unit,
        model.display_unit,
        model.is_unit_fixed
    );

    return new Handlebars.SafeString(
        '<strong>' +
            Handlebars.escapeExpression(valueDisplayInfos.value) +
            '</strong>&nbsp;' +
            Handlebars.escapeExpression(valueDisplayInfos.unit)
    );
});

Handlebars.registerHelper('DISPLAY_VALUE_PLAIN', function (model, value, attribute) {
    if (!attribute) {
        value = model.data[model.type + '_' + model.nr];
    }
    var valueDisplayInfos = Misc.getValueDisplayInfos(
        value,
        model.type,
        model.format,
        model.unit,
        model.display_unit,
        model.is_unit_fixed
    );

    return (
        Handlebars.escapeExpression(valueDisplayInfos.value) + ' ' + Handlebars.escapeExpression(valueDisplayInfos.unit)
    );
});

Handlebars.registerHelper('COLUMN_DATA', function (model, attribute, displayMethod) {
    if (!displayMethod) {
        switch (model.modelType) {
            case 'device':
            case 'filter_result':
                return deviceColumnData(model, attribute);
            case 'value':
                return valueColumnData(model, attribute);
            case 'user_admin_entry':
                return userAdminColumnData(model, attribute);
            case 'mailbox':
                return mailColumnData(model, attribute);
            case 'company_user':
                return companyUser(model, attribute);
            case 'gateway_statistic':
                return gatewayStatistic(model, attribute);
        }
    }

    if (attribute.startsWith('#_')) {
        attribute = attribute.substring(2);
    }

    if (displayMethod) {
        var stdFunctions = {
            datetime: function (x) {
                if (!x) return '--';

                if (moment.utc(x).format('x') <= 0) return '--';
                return Handlebars.helpers.TIME(x);
            },
            filter: function (x) {
                return AppState.filterToStr(x);
            },
            device: function (x) {
                return deviceColumnData(model, attribute);
            },
        };

        var fct = stdFunctions[displayMethod] || displayMethod;
        var result = undefined;

        if (fct.method) {
            switch (fct.method) {
                case 'device':
                    return getDeviceLink(model[fct.attrID], model[fct.attrName], model[fct.attrCategory]);
            }
        } else {
            result = fct(model[attribute], model, attribute) || '';
        }

        var completeResult = function () {
            switch (result.type) {
                case 'link':
                    // type ignored, class, href, text are used, the rest comes as -data
                    result.href = result.href || 'javascript:void(0);';
                    var linkParts = [];
                    _.each(result, function (value, key) {
                        switch (key) {
                            case 'class':
                            case 'href':
                                linkParts.push(key + '="' + Handlebars.escapeExpression(value) + '"');
                                break;
                                break;
                            case 'text':
                            case 'type':
                                break;
                            default:
                                linkParts.push('data-' + key + '="' + Handlebars.escapeExpression(value) + '"');
                                break;
                        }
                    });

                    return '<a ' + linkParts.join(' ') + '>' + Handlebars.escapeExpression(result.text || '') + '</a>';
                default:
                    return result;
            }
        };

        return completeResult();
    }

    return Handlebars.escapeExpression(model[attribute] || '--');
});

Handlebars.registerHelper('JSON', function (object, ident) {
    return JSON.stringify(object, null, ident);
});

Handlebars.registerHelper('DEFAULT', function (object, defaultValue) {
    return Handlebars.escapeExpression(object || defaultValue);
});

Handlebars.registerHelper('EQ', function (o1, o2, result) {
    return o1 == o2 ? result : '';
});

Handlebars.registerHelper('NEQ', function (o1, o2, result) {
    return o1 != o2 ? result : '';
});

Handlebars.registerHelper('IS_CHECKED', function (value) {
    return value ? ' checked ' : '';
});

Handlebars.registerHelper('DEVICE_SELECT', function (selectedValue, styleClass, content) {
    // no styleclass given? -> second argument is content
    content = content || styleClass;
    return DeviceDropDownList.create(content.fn(this), selectedValue, styleClass);
});

Handlebars.registerHelper('IF_AVAILABLE', function (field, content) {
    return AppState.availableColumnData(field) ? content.fn(this) : content.inverse(this);
});

Handlebars.registerHelper('IF_AVAILABLE_ANY', function () {
    var isAvailable = false;
    for (var i = 0; i < arguments.length - 1; i++) {
        isAvailable = isAvailable || AppState.availableColumnData(arguments[i]);
    }
    return isAvailable ? arguments[arguments.length - 1].fn(this) : arguments[arguments.length - 1].inverse(this);
});

Handlebars.registerHelper('IF_AVAILABLE_ALL', function () {
    var isAvailable = true;
    for (var i = 0; i < arguments.length - 1; i++) {
        isAvailable = isAvailable && AppState.availableColumnData(arguments[i]);
    }
    return isAvailable ? arguments[arguments.length - 1].fn(this) : arguments[arguments.length - 1].inverse(this);
});

// preselects the value 'selectValue' from a <select>-tag
Handlebars.registerHelper('SELECT', function (selectedValue, content) {
    if (typeof selectedValue === 'function') {
        selectedValue = selectedValue();
    }
    var selectedValues = _.flatten([selectedValue]);

    var el = $(document.createElement('div'));
    el.html(content.fn(this));

    _.each(selectedValues, function (sv) {
        var isExcluded = false;
        if (sv && sv.startsWith && sv.startsWith('_-_')) {
            sv = sv.substring(3);
            isExcluded = true;
        }
        el.find('option[value="' + sv + '"]').attr('selected', true);
        if (isExcluded) {
            el.find('option[value="' + sv + '"]').attr('data-excluded', true);
        }
    });

    var isMultiple = $(el).find('select.multi-select[multiple="multiple"]').length > 0;
    if (!isMultiple) {
        DropDownList.create(el, selectedValues);
    }
    return el.html();
});

Handlebars.registerHelper('CHART-OPERATOR', function (object) {
    return Misc.selectWhereFirst(
        Consts.Backend.Operators,
        function (a) {
            return a.value == object;
        },
        function (a) {
            return I18N.TR(a.name);
        }
    );
});

Handlebars.registerHelper('CHART-LABEL', function (showCustom, object) {
    var r = object.data.root;
    if (r && r.lines && r.lines[object.data.index]) {
        return Misc.getChartLineLabel(object.data.index, r, showCustom, AppState);
    }
    return '';
});

Handlebars.registerHelper('QUICK_NAVIGATION', function (navLinks) {
    return QUICK_NAVIGATION({ links: QuickNavigationLinks({ links: navLinks }) });
});

Handlebars.registerHelper('ALARM_NOTIFICATION', function (object) {
    var byCurrentUser = object.data.root.by_current_user;
    var notificationData = object.data.root.custom_data;
    var notificationMsgText = {
        1: I18N.TR('eine SMS'),
        2: I18N.TR('eine E-Mail'),
        3: I18N.TR('eine SMS und eine E-Mail'),
    };

    var notificationText = {
        true: I18N.TR('Sie haben %s erhalten.'),
        false: I18N.TR('Ein Benutzer hat %s erhalten'),
    };

    var msgMask = (notificationData.indexOf('email') > -1 ? 2 : 0) | (notificationData.indexOf('sms') > -1 ? 1 : 0);

    // someone else has received nothing - we don't really need to inform you about that :-)
    if (!msgMask) {
        return '';
    }

    return notificationText[byCurrentUser].replace('%s', notificationMsgText[msgMask]);
});

// like "if" but with the ability to use some logical operators. Example:
// {{#compare Database.Tables.Count ">" 5}}
// There are more than 5 tables
// {{/compare}}
// to check for equality, the operator can be omitted
Handlebars.registerHelper('COMPARE', function (lvalue, operator, rvalue, options) {
    if (options === undefined) {
        options = rvalue;
        rvalue = operator;
        operator = '===';
    }

    return Misc.evaluateToBool(lvalue, operator, rvalue) ? options.fn(this) : options.inverse(this);
});

Handlebars.registerHelper('HAS_OBJVALUE', function (obj, field, options) {
    if (obj === undefined || obj[field] === undefined) {
        return options.inverse(this);
    } else {
        return options.fn(this);
    }
});

// SWITCH/CASE based on http://chrismontrois.net/2016/01/30/handlebars-switch/

Handlebars.registerHelper('SWITCH', function (value, options) {
    var data = options.data || {};
    data._switch_state = { value: value, found: false };

    return options.fn(this, { data: data });
});

Handlebars.registerHelper('CASE', function (value, options) {
    var state = options.data._switch_state;
    if (value == state.value || (value === undefined && !state.found)) {
        state.found = true;
        return options.fn(this, options);
    }
});

Handlebars.registerHelper('FIXED_POINT', function (value, digits) {
    return Strings.fixedPoint(value, digits);
});

Handlebars.registerHelper('ARRAY_OBJ', function (array, index, field) {
    return array[index][field];
});

Handlebars.registerHelper('ALARMCOL', function (lvalue, operator, rvalue, options) {
    var result = '<th data-sort-col="' + lvalue + '">';
    result += operator.fn();

    if (lvalue == operator.data.root.sortCol)
        result +=
            ' <span><i class="fa fa-long-arrow-' + (operator.data.root.sortDesc ? 'down' : 'up') + '"></i></span>';

    result += '</th>';
    return result;
});

Handlebars.registerHelper('REPEAT', function (from, till, content) {
    var result = '';
    for (var i = from; i <= till; i++) {
        result += content.fn({ i: i });
    }
    return result;
});

Handlebars.registerHelper('ACCORDION', function (nameArray, selected, content) {
    if (content === undefined) {
        content = selected;
        selected = nameArray;
        nameArray = undefined;
    }

    if (content === undefined) {
        content = selected;
        selected = undefined;
    }

    var data = { tabs: [], nameArray: nameArray || {} };
    var contentHTML = content.fn(this, { data: data });
    Handlebars._trovis_accordion_id = (Handlebars._trovis_accordion_id || 0) + 1;
    var accordionID = 'accordion_' + Handlebars._trovis_accordion_id;
    if (data.tabs.length > 0 && selected !== undefined) {
        data.tabs[selected].selected = true;
    }

    var template = require('utils/templates/accordion');
    return template({
        accordion_id: accordionID,
        tabs: data.tabs,
    });
});

Handlebars.registerHelper('ACCORDION-TAB', function (title, icon, content) {
    if (content === undefined) {
        content = icon;
        icon = undefined;
    }

    var contentHTML = content.fn(this);
    content.data.tabs.push({
        title: content.data.nameArray[title] || title,
        icon: icon,
        content: contentHTML,
        idx: content.data.tabs.length,
    });

    return '';
});

Handlebars.registerHelper('TEMPLATE', function (ctx, name, content) {
    if (ctx.called) {
        if (ctx.called == name) {
            return content.fn(ctx.data, { data: ctx.data });
        }
    }
    ctx.items = ctx.items || {};
    ctx.items[name] = content.fn;
    return '';
});

Handlebars.registerHelper('FILTER', function (filter, content) {
    var template = require('utils/templates/filter');
    return template({
        filterText: AppState.filterToStr(filter),
        showClear: Misc.hasFilterSet(filter),
    });
});

Handlebars.registerHelper('WIZARD', function (context, content) {
    // initialize context
    context.selected = context.selected || 1;

    // vars
    var template = require('utils/templates/wizard');
    var tabs = [];
    var data = content.data || {};
    data._wizard = { tabs: tabs, currentTab: 1, activeTab: context.selected, ctx: context, tabCount: 0 };

    // process the content
    var contentHTML = content.fn(this, { data: data });
    context.permCtx.tabCount = data._wizard.tabCount;

    // build tabs
    tabs = Misc.selectWhere(tabs, undefined, function (tab) {
        return {
            isFirst: tab.idx == 1,
            isLast: tab.idx == tabs.length,
            isSelected: tab.idx == context.selected,
            idx: tab.idx,
            title: context.tabNames[tab.title] || tab.title,
        };
    });

    // decide class, if not passed already
    if (!context.class) {
        var classes = { 1: 'two', 2: 'two', 3: 'three', 4: 'four' };
        context.class = classes[tabs.length] || 'four';
    }

    context.tabCount = tabs.length;

    return template({
        tabs: tabs,
        wizard_class: context.class,
        content: contentHTML,
    });
});

Handlebars.registerHelper('DEVICE-FILTER', function (cfg) {
    var template = require('../components/devices/templates/common/device_filter_region');
    if (cfg.wizardCtx) cfg.filterTab = cfg.wizardCtx.renderingTab;
    return template(cfg);
});

Handlebars.registerHelper('DEVICE-SELECT', function (cfg) {
    var template = require('../components/devices/templates/common/device_select_region');
    if (cfg.wizardCtx) cfg.selectionTab = cfg.wizardCtx.renderingTab;
    return template(cfg);
});

Handlebars.registerHelper('LIST', function (sep, content) {
    if (!content) {
        content = sep;
        sep = ', ';
    }

    var prevData = content.data;
    var prevList = prevData ? prevData.__template_list : undefined;

    content.data = content.data || {};
    content.data.__template_list = {
        items: [],
    };

    content.fn(this);
    var list = _.compact(content.data.__template_list.items);
    var result = list.join(sep);
    if (prevData) prevData.__template_list = prevList;
    content.data = prevData;

    if (!list.length) return content.inverse(this);
    return result;
});

Handlebars.registerHelper('LI', function (content) {
    content.data.__template_list.items.push(content.fn(this));
});

Handlebars.registerHelper('WIZARD-TAB', function (title, content) {
    content.data._wizard.tabCount++;
    content.data._wizard.tabs.push({ title: title, idx: content.data._wizard.currentTab });
    content.data._wizard.ctx.renderingTab = content.data._wizard.currentTab;
    content.data._wizard.currentTab++;
    if (content.data._wizard.currentTab - 1 != content.data._wizard.activeTab) return '';

    content.data._wizard.ctx.permCtx.selectedName = title;

    var contentHTML = content.fn(this);
    return contentHTML;
});

Handlebars.registerHelper('WIZARD-BUTTONS', function (context) {
    var template = require('utils/templates/wizard_buttons');
    return template(context);
});

Handlebars.registerHelper('MATH', function (lvalue, operator, rvalue, options) {
    lvalue = parseFloat(lvalue);
    rvalue = parseFloat(rvalue);

    return {
        '+': lvalue + rvalue,
        '-': lvalue - rvalue,
        '*': lvalue * rvalue,
        '/': lvalue / rvalue,
        '%': lvalue % rvalue,
    }[operator];
});

Handlebars.registerHelper('COPYRIGHT', function () {
    var template = require('utils/templates/copyright_note');
    return template({ year: new Date().getFullYear(), isTestEnvironment: TC_DEBUG });
});

Handlebars.registerHelper('DESCRIPTION', function (key, model, name, resultValue) {
    if (resultValue === undefined || typeof resultValue != 'string') {
        resultValue = model[key];
    }

    if (key == 'wired_to' || key == 'parent') {
        if (!resultValue || resultValue === model.id) {
            return;
        }
        if (Misc.isInteger(resultValue)) {
            resultValue = deviceLinkFct(resultValue);
        }
    }

    if (resultValue != undefined) {
        if (
            !model.isExternalDevice &&
            (model.deviceCategory == 'Meter' || model.deviceCategory == 'FakeMeter') &&
            key == 'hardware'
        ) {
            resultValue = Strings.meterManufacturer(resultValue);
        }

        if (key == 'filter' && model.deviceCategory == 'Virtual') {
            resultValue = AppState.filterToStr(resultValue);
        }

        if (key == 'station' && model.category == 'Gateway-RF' && (resultValue == -1 || resultValue == 254)) {
            return;
        }

        if (key == 'firmware' && model.firmwareInfo !== undefined && model.firmwareInfo.isValid) {
            var firmwareInfoDisplay = '';
            var firmwareInfoProgress = '';

            var firmware = model.firmwareInfo;
            var job = firmware.job;

            if (firmware.updatePossible && firmware.available != '--') {
                // update available
                firmwareInfoDisplay = I18N.TR('Firmware Update verfügbar') + ': <i>' + firmware.available + '</i>';
            } else if (job.state == 'WAITING') {
                // update scheduled, but not active
                firmwareInfoDisplay = I18N.TR('Firmware Update geplant') + ': <i>' + firmware.available + '</i>';
            } else if (job.state == 'RUNNING') {
                // data transfer running, show progress
                firmwareInfoDisplay =
                    I18N.TR('Firmware Update wird übertragen') + ': <i>' + firmware.available + '</i>';
                firmwareInfoProgress +=
                    '<div class="progress progress-md"><div class="progress-bar progress-bar-info" role="progressbar" style="width: ' +
                    job.progress +
                    '%;">' +
                    job.progress +
                    ' %</div></div>';
            } else if (job.state == 'FINALIZING') {
                // device update
                firmwareInfoDisplay =
                    I18N.TR('Firmware Update wird durchgeführt') + ': <i>' + firmware.available + '</i>';
            } else if (job.retry_count >= 5) {
                // device update failed
                firmwareInfoDisplay =
                    '<i class="fa fa-exclamation-triangle warning"></i>&nbsp;' +
                    I18N.TR('Firmware Update mehrfach fehlgeschlagen') +
                    ': <i>' +
                    firmware.available +
                    '</i>';
            }

            if (firmwareInfoDisplay != '') {
                resultValue = resultValue + ' (&nbsp;' + firmwareInfoDisplay + '&nbsp;)' + firmwareInfoProgress;
            }
        }

        return '<dt id="ct-' + key + '">' + name + '</dt><dd>' + resultValue + '</dd>';
    }
});

Handlebars.registerHelper('INSERT_DEVICE_ICON', function (type) {
    return Misc.convertValue(type, Consts.Category, Consts.Icons);
});

Handlebars.registerHelper('OBJVALUE', function (obj, key) {
    return new Handlebars.SafeString(obj[key]);
});

Handlebars.registerHelper('JSON_OBJVALUE', function (obj, key) {
    obj = Misc.parseAsJSON(obj);
    return new Handlebars.SafeString(obj ? obj[key] : '');
});

Handlebars.registerHelper('PERMISSIONS_CONTROL', function (permissionsData) {
    var template = require('utils/templates/permissions');
    return template(permissionsData);
});

Handlebars.registerHelper('FIELD_VALUE', function (fvid, fieldName, owner, key, fieldValuesEnum, size) {
    var template = require('utils/templates/field_value');
    return template(FieldValue.getTemplateData(fieldName, owner, key, fieldValuesEnum, fvid, size));
});

Handlebars.registerHelper('ERROR_ROW', function (name, errInfo, content) {
    if (!content) {
        errInfo = undefined; // only 1 parameter
    }
    var template = require('utils/templates/error_row');
    var addText = errInfo ? ' (' + errInfo + ')' : '';
    var errText = (Consts.ErrorMessages[name] || name || '') + addText;
    return new Handlebars.SafeString(template({ error: errText }));
});

Handlebars.registerHelper('FIELDS_LIST_BOX', function (selectedFields, elementId, elementName, fields) {
    var template = require('components/common/templates/fields_select');
    return new Handlebars.SafeString(
        template({
            selectedFields: selectedFields,
            elementId: elementId,
            elementName: elementName,
            fields: fields,
        })
    );
});

Handlebars.registerHelper('SHIFT_DECIMAL', function (shift, value) {
    return value / Math.pow(10, shift);
});

Handlebars.registerHelper('CALCULATE', function (leftValue, operator, rightValue) {
    leftValue = parseFloat(leftValue);
    rightValue = parseFloat(rightValue);
    switch (operator) {
        case '+':
            return leftValue + rightValue;
        case '-':
            return leftValue - rightValue;
        case '*':
            return leftValue * rightValue;
        case '/':
            return leftValue / rightValue;
    }
});

Handlebars.registerHelper('ERROR_TR', function (errorString) {
    var error_dict = {
        'Modbus error': I18N.TR('Modbus Fehler'),
        'Unable to initialize device': I18N.TR('Gerät konnte nicht initialisiert werden'),
    };
    return error_dict[errorString] || I18N.TR(errorString);
});

Handlebars.registerPartial({
    ADD_CUSTOM_VALUE: require('../components/scheme/templates/add_custom_value.hbs'),
    ADD_CUSTOM_TEXT: require('../components/scheme/templates/add_custom_text.hbs'),
    ALERT: require('../components/common/templates/alert.hbs'),
    ALARM_MENU_ENTRY: require('../components/menubar/templates/menubar_alarms.hbs'),
    CHARACTERISTIC_4_POINT_CONFIG: require('../components/devices/templates/controller/characteristic_4_point_config.hbs'),
    CHARACTERISTIC_4_POINT_GRAPH: require('../components/devices/templates/controller/characteristic_4_point_graph.hbs'),
    CHARACTERISTIC_CONSTANT: require('../components/devices/templates/controller/characteristic_constant.hbs'),
    CHARACTERISTIC_GRADIENT_CONFIG: require('../components/devices/templates/controller/characteristic_gradient_config.hbs'),
    CHARACTERISTIC_GRADIENT_GRAPH: require('../components/devices/templates/controller/characteristic_gradient_graph.hbs'),
    CHARACTERISTIC_LAYOUT: require('../components/devices/templates/controller/characteristic_layout.hbs'),
    DESKTOP_MENUBAR: require('../components/menubar/templates/desktop.hbs'),
    EVENT_LOG_ITEM: require('../components/devices/templates/common/event_log_item.hbs'),
    IMPRINT_CONTENT: require('../components/help/templates/imprint_content.hbs'),
    MOBILE_MENUBAR: require('../components/menubar/templates/mobile.hbs'),
    MULTISELECT_FILTER: require('../components/common/templates/multiselect_filter.hbs'),
    PARAMETER_READ_ONLY: require('../components/devices/templates/controller/parameter_read_only.hbs'),
    PARTIAL_FOOTER: require('../components/account/templates/footer.hbs'),
    PROFILE_MENU_ENTRY: require('../components/menubar/templates/profile.hbs'),
    STATUS_MENU_ENTRY: require('../components/menubar/templates/status.hbs'),
    WIDGET_BAR: require('../components/common/widgets/templates/widget_bar.hbs'),
    WIDGET_PERCENT: require('../components/common/widgets/templates/widget_percent.hbs'),
    DRINKING_WATER_GRAPHIC: require('../components/common/templates/svg/drinking_water_graphic.hbs'),
    DRINKING_WATER_DAY_MARKER: require('../components/common/templates/svg/drinking_water_day_marker.hbs'),
    DRINKING_WATER_NIGHT_MARKER: require('../components/common/templates/svg/drinking_water_night_marker.hbs'),
    DRINKING_WATER_HANDLE: require('../components/common/templates/svg/drinking_water_handle.hbs'),
    BUTTON_PRESSED_SUN: require('../components/common/templates/svg/button_pressed_sun.hbs'),
    BUTTON_PRESSED_MOON: require('../components/common/templates/svg/button_pressed_moon.hbs'),
    BUTTON_RELEASED_SUN: require('../components/common/templates/svg/button_released_sun.hbs'),
    BUTTON_RELEASED_MOON: require('../components/common/templates/svg/button_released_moon.hbs'),
    BUTTON_PRESSED_TEXT: require('../components/common/templates/svg/button_pressed_text.hbs'),
    BUTTON_RELEASED_TEXT: require('../components/common/templates/svg/button_released_text.hbs'),
    Y_AXIS: require('../components/common/templates/svg/y_axis.hbs'),
    OVERVIEW_PANEL: require('../components/devices/templates/gateway/overview_panel.hbs'),
    MESSAGE: require('../components/common/templates/message.hbs'),
    VALUE_TABLE: require('../components/common/templates/value_table.hbs'),
    WARNING_HINTS: require('../components/devices/templates/common/warning_hints.hbs'),
    WRITE_VALUE_ABSOLUTE: require('../components/devices/templates/common/write_value_absolute.hbs'),
    WRITE_VALUE_RELATIVE: require('../components/devices/templates/common/write_value_relative.hbs'),
    WRITE_VALUE_WEATHER: require('../components/devices/templates/common/write_value_weather.hbs'),
});
